import Tabs, { TabItem } from 'components/Tabs/Tabs';
import { ProductExploreTabKey } from 'utils/constants';

function ProductsCategories({
  productTabs,
  onClickItem,
  activeIndex,
  isMobile = false
}: {
  productTabs: TabItem<ProductExploreTabKey>[];
  onClickItem: (item: TabItem<ProductExploreTabKey>) => void;
  activeIndex: number;
  isMobile?: boolean;
}) {
  return (
    <div className="flex whitespace-nowrap hidden xl:flex w-full overflow-x-auto no-scrollbar">
      <Tabs
        underline={false}
        items={productTabs}
        activeIndex={activeIndex}
        onClickItem={onClickItem}
        small={isMobile}
        className='pl-2 gap-2'
        weight={'normal'}
      />
    </div>
  );
}

export default ProductsCategories;
